export default __webpack_public_path__ + "static/media/click-button.d2d6ea18.mp3";